import React, { useEffect, useState } from 'react';
import LandingBeneficio from '../components/bodas/LandingBeneficio';

export default function BodasPreview() {
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    const recibir = (e) => {
      if (e.origin !== window.location.origin || !e.data?.__jpmPreview || !e.data.datos) return;
      setPayload(e.data);
    };
    window.addEventListener('message', recibir);
    try { window.parent?.postMessage({ __jpmPreviewReady: true }, window.location.origin); } catch (err) { /* sin ventana padre */ }
    return () => window.removeEventListener('message', recibir);
  }, []);

  if (!payload) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm" style={{ color: '#9b917f', fontFamily: 'system-ui, sans-serif', background: '#F3EFE3' }}>
        Vista previa…
      </div>
    );
  }
  return (
    <LandingBeneficio variante={payload.variante} datos={payload.datos} contacto={payload.contacto}
      borrador={payload.borrador} avisoBorrador={payload.avisoBorrador} vistaPrevia sinAnimacion />
  );
}
